import i18n from './index.js'
export default {//日语
  translateText: {
    shoppingcart: "ショッピングカートです",
    loginorrefisterText: "登録します",
    logoutText: "ログアウトします",
    personcenterText: "個人センターです",
    placeholderText: "選んでくださいです",
    loginText: "ログインです",
    registerText: "登録です",
    emailText: "メールです",
    pwdText: "パスワードです",
    forgetpwdText: "パスワードを忘れましたか? ",
    nameText: "「名前です」",
    surnameText: "名前",
    mobileText: "電話です",
    setPwdText: "パスワードを設定します",
    confirmpwdText: "「パスワードを確認します」",
    countryText: "「国」",
    company: "「会社」",
    birthday: "「誕生日」",
    yearText: "年",
    mouthText: "「月」",
    dayText: "「日」",
    confirmpwdText: "パスワードを確認します",
    agreeText1: "読んで同意しました",
    agreeText2: "使用条件です",
    agreeText3: "や",
    agreeText4: "プライバシー声明です",
    agreeText5: ",そして私の箇人情報の一部はプライバシー宣言に従って国外で処理することに同意します。",
    emailplaceholder: 'メールをお願いします',
    subscribetitleText: 'ニュース通信を購読しています',
    subscribeText: '購読',
    shareToText: '分かち合います',
    searchText: "「検索します」",
    subtractmoneyText: "最大マイナス600",
    magnanimitycouponText: "「大量クーポンお待ちしております」",
    drawText: "「すぐに受け取ります」",
    discountText: "「超割引」です",
    purchaseText: "すぐに購入します",
    composecouponText: "「組み合わせ購入」です",
    manyDiscountsText: "「お得です」",
    recommendtitleText: "「あなたにお勧めします」",
    hotsaleproductyitleText: "ヒット商品です",
    guessLiketitleText: "あなたの好きなことを当ててください",
    NoDataText: "「仮のデータはありません」",
    appraiseText: "評価します",
    certificate: "「チケット」です",
    collectText: "「コレクション」です",
    addCartText: "「カートに入れます」",
    enterkeywordsText: "キーワードを入力します",
    useNowText: "「すぐに使え」です",
    vouchernoText: "「チケット番号」です",
    placeholderyearText: "「選ぶ年」です",
    placeholdermouthText: "「選択月間」です",
    placeholderdayText: "「選択の日」です",
    // 优惠券页面
    breadcrumbItemText1: "「超」です",
    breadcrumbItemText2: "「レベル」です",
    breadcrumbItemText3: "「大きい」です",
    breadcrumbItemText4: "「幸せです」",
    breadcrumbItemText5: "「利」です",
    magnanimitydrawText: "「あなたを待ちます」",
    availablecouponstitleText: "可用券製品",
    drawbtnText: '受け取ります',
    universalText: "「全場共通」",
    useText: "「使います」",
    limitText: "「限ります」",
    fullText: "「いっぱいです」",
    subtractText: "「引く」です",
    // 折扣
    discountitemText1: '割引が続きます ,',
    discountitemText2: '鉅恵連連です',
    // 组合
    commoditydiscountitemText1: '組み合わせ買いです ,',
    commoditydiscountitemText2: '割引が多いです',
    combinedpriceText: '組み合わせ価格です',
    economizeText: '節約',
    buynowText: "即購入です",
    // 产品
    ourproductsText: "「私たちの製品」です",
    productcategoryText: "「製品群」です",
    recommendtarText: "「推薦します」",
    newText: "新商品です",
    salesvolumetarText: "「売れます」",
    pricetarText: "価格です",
    // 博客
    blogmanagementText: "「人気ブログ」です",
    latestblogsText: "「最新ブログ」です",
    relatedrlogsText: "「関連ブログ」です",
    priceIncreasecommentText: "値上げ评论",
    commentsectionTtxt: "「コメント欄」です",
    participatingcommentsText: "評論に参加します",
    // 论坛
    postingText: "「書き込み」です",
    topicsText: "テーマです",
    replyText: "「返信します」",
    viewText: "「見ます」",
    lastreplyText: "「最後の返事」です",
    publishText: "「リリース」です",
    placeholdertypeText: "「テーマ分類を選択してください」",
    placeholdertitleText: "「タイトルを入力してください」",
    placeholdercontentsText: "「内容を入力してください」",
    fromtopicText: "より来主題:",
    firstfloor: "1階です",
    floorText: "「ビル」です",
    fromText: "由来:",
    postreplyText: "「返事を出します」",
    // 个人中心 - 我的订单
    myorderText: "「マイオーダー」",
    mycommentsText: "「私のコメント」",
    mycollectionText: "「私のコレクション」",
    couponText: "「クーポン」",
    shippingaddressText: "「お届けします」",
    myPostText: "「私のレス」",
    personalinformationText: "「個人情報」",
    editText: "編集です",
    allordersText: "「全て註文します」",
    unpaidText: "「支払い待ちです」",
    shippedText: "「待ちます」",
    receivedText: "「待ちます」",
    evaluatedText: "「待ちます」",
    baidText: "「支払い代行」です",
    completedText: "「完成しました」",
    productinfText: "「製品情報」です",
    unitpricethText: "単価",
    quantitythText: "「数」です",
    actualpaymentthText: "「実際に支払います」",
    transactionstatusthText: "「取引状態」です",
    operationthText: "「操作」です",
    ordernumberText: "「註文番号」です",
    orderdetailsText: "注文書詳細",
    cancelorderText: "「キャンセルします」",
    confirmText: "「確かです」",
    cancelText: "キャンセルします",
    deleteordertitle: "「現在の註文を削除しますか?」と",
    successfultradeText: "「取引できました」",
    paymentText: "「支払い」",
    confirmreceiptText: "「受け取りを確認します」",
    nncommentText: '暫く評論しません',
    // 个人中心 - 我的评论
    productText: "「製品」です",
    productdetailText: "レビューの詳細",
    replyblogText: "回復ブログ:",
    //个人中心 - 收货地址
    addseliveryaddressText: "「新増収荷住所」",
    addaddresstitleText1: "「保存しました」",
    addaddresstitleText2: "箇条アドレス、まだ保存することができます",
    addaddresstitleText3: "「箇条アドレス」です",
    defaultText: "「デフォルト」です",
    consigneeText: "受取人:",
    addressText: "所在住所:",
    fulladdressText: "詳しい住所:",
    setdefaultText: "デフォルトに設定します",
    text: "携帯電話:",
    viewmoreText: "「もっと見ます」",
    replypostText: "回復招待状:",
    // 个人中心 - 个人信息
    nameLabel: "名前です",
    セクスラベル: "「性別」です",
    modifyavatarText: "「画像を修正します」",
    sexmanText: "「男」です",
    sexwomanText: "女性です",
    secrecyText: "秘密を守ります",
    replaceText: "「交換します」",
    saveText: "「保存」",
    oldpasswordText: "「元のパスワード」です",
    newpasswordText: "新しいパスワードです",
    confirmpasswordText: "「パスワードを確認します」",
    opdpleasolderText: "元のパスワードを入力してください",
    newpleasolderText: "新しいパスワードを入力します",
    unboundText: "未バインディングです",
    bindingText: "「バインディング」です",
    unbindingText: "「解除します」",
    // 个人中心-个人信息
    regionText:"「地域」です",
    addconsigneleasolderText: "ください受取人の氏名を记入してください",
    countrypleasolderText: "「国を選びなさい」です",
    provinceleasolderText: "「省を選びます」",
    citypleasolderText: "「市を選びます」",
    areapleasolderText: "区を選択してください",
    fulladdressTextpleasolderText: "詳細住所を入力してください",
    addconsignephoneleasolderText: "記入ください受取人の携帯電話の番号",
    emailpleasolderText: "「電子メールのアドレスを入力してください」",
    phoneText: "携帯電話の番号です",
    uploadimgText:"「画像をアップロードします」",
    updateuserface:"「プロフィール画像を修正します」",
    uploadimgtitle1: " jpg、jpeg、png形式の画像をサポートします",
    uploadimgtitle2: "推奨サイズ:200*200または均等比例画像",
    updateemailText:"「メールボックスを修正します」",
    updatemobileText:"「携帯電話番号を変更します」",
    dialogemailtitle:"「eメールアドレス」です",
    dialogmobiletitle:"携帯電話の番号です",
    dialogheadertitle: "入力とあなたの錦格のアカウントに関連します",
    continueText: "続きます",
    verificationinformation:"「検証情報」です",
    verificationinformationtitle1: "続けなければならず、これを検証手続きを完成してください。私たちはに行きました",
    verificationinformationtitle2: "検証ヤードを送った。下記に入力をお願いします。",
    verificationcode:"認証コード",
    newtitle:"新しいです",
    dialognewmobiletitle: "関連する新しい携帯番号を入力します。「交換確認」をクリックします",
    confirmpbtnText:"「確認します」",
    titlecpuntryselect:"「国を選ぶ」です",
    hotcountrytitle:"「ホットな国」です",
    aboutusText:"「私たちについて」です",
    // 订单详情
    havequestionsText:"質問があります",
    preferentialText:"「特別です」",
    enquiryText:"「引合いです」",
    combinationdiscountText:"「組み合わせ特典」です",
    introduceText:"「紹介します」",
    buyermycommentsText:"「バイヤーレビュー」です",
    starText: "星",
    yourmailboxText:"あなたのメールです",
    placeholderquestionText:"「あなたの質問を書いてください」",
    uploadimglimtText: "JPG/GIF/PNGファイルをアップロードします。画像サイズは2MBを超えてはいけません。と",
    submitbtnText:"「提出」",
    // 购物车
    selectText:"選択します",
    tipscartsText:"「既選品(送料含まず)」",
    settlementText:"「決済します」",
    selectallText:"「すべてを選びます」",
    amountText:"「お金です」",
    addtofavoritesText:"「お気に入りに入れます」",
    havecollectedText: "収蔵しました",
    tipdelecteproduct:"「現在の商品を削除しますか?」と",
    deleteText:"「削除します」",
    tipclearcart:"「カートを空にしますか?」と",
    clearcartText:"「ショッピングカートを空にします」",
    totalText:"「合計します」",
    totaltipText: "(送料を含みません):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_ja.js